import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { FILE_SYSTEM_CONFIG } from '@lib/constants';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.API_URL;

    getProfile(userId: string) {
        return this.http.get<any>(`${this.baseUrl}/user/profile/${userId}`);
    }

    updatePublish(userId: string, publish: boolean) {
        return this.http.patch<any>(`${this.baseUrl}/user/profile/${userId}?publish=${publish}`, {});
    }

    updateProfile(userId: string, profile: any) {
        return this.http.put<any>(`${this.baseUrl}/user/profile/${userId}`, profile);
    }

    getSalutations() {
        return this.http.get<any>(`${this.baseUrl}/salutation`);
    }

    uploadProfilePicture(userId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('referenceId', userId);
        formData.append('key', FILE_SYSTEM_CONFIG.PROFILE.KEY);
        formData.append('baseFolderName', FILE_SYSTEM_CONFIG.PROFILE.BASE_FOLDER_NAME);

        return this.http.post<any>(`${this.baseUrl}/file-system`, formData);
    }
}
